export var FileType;
(function (FileType) {
    FileType["SET"] = "set";
    FileType["DRAWING"] = "drawing";
    FileType["SCRAPBOOK"] = "scrapbook";
    FileType["DOCUMENT"] = "document";
    FileType["SPECIFICATION"] = "specification";
    FileType["PHOTO"] = "photos";
    FileType["ALBUM"] = "album";
    FileType["FOLDER"] = "folder";
})(FileType || (FileType = {}));
export var FileStatus;
(function (FileStatus) {
    FileStatus["CREATED"] = "created";
    FileStatus["DELETED"] = "deleted";
})(FileStatus || (FileStatus = {}));
